import { Component, Input, OnInit, ViewChild, inject, DestroyRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { translate } from '@jsverse/transloco';
import { Constants } from 'src/app/models/constants';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AddCapabilityDialogComponent } from '../add-capability-dialog/add-capability-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';

@Component({
    selector: 'app-add-build-version-form',
    templateUrl: './add-build-version-form.component.html',
    styleUrls: ['./add-build-version-form.component.scss'],
    standalone: false
})
export class AddBuildVersionFormComponent  implements OnInit {
  @ViewChild(MatSort, {static: true}) sort;
private destroyRef = inject(DestroyRef);

  @Input() set data(data: any) {
    this.editData = data;
  };
  @Input() edit;
  editData: any;
  Constants = Constants;
  title: string;
  createVersionForm: FormGroup;
  statusOptions: any;
  loading = false;
  displayedColumns: string[] = ['capability', 'version', 'type', 'icon'];
  createSpecForm: any;
  selectedIndex = 0;
  dataSource: any = [];
  tabValidation: any = {
    basic: false,
    capability: false,
    installSpec: false,
    review: false
  };
  encryptionKeys: any = {
    buildInstallSpec: false
  };
  capabilityCount: any = {};
  sortInfo: any = {};
  patchFlagValue = true;

  constructor(private matDialog: MatDialog, private formBuilder: FormBuilder, public sidenavService: SidenavService) {
    
  }

  ngOnInit(): void {
    this.title = this.edit ? translate('ADD_VERSION.EDIT_BUILD_VERSION') : translate('ADD_VERSION.ADD_NEW_BUILD_VERSION');
    this.statusOptions = [
     'dev',
     'test',
     'published',
     'sunset',
     'deprecated',
     'comingsoon'
    ];
    if (localStorage.getItem('capabilities') || this.editData) {
      if (this.editData) {
        this.editData.capabilities?.map(item => {
          item.capability = item?.name;
          item.type = item?.required;
        });
      }
      this.dataSource = this.editData?.capabilities ? this.editData?.capabilities : JSON.parse(localStorage.getItem('capabilities')) || [];
      this.updateCapabilityCount();
    }
    this.createForm();
    this.specForm();
  }

  getVersionForm(): any {
    if (!FormUtilService.validateForm(this.createVersionForm)) {
      return;
    }
    return this.createVersionForm.getRawValue();
  }

  getSpecForm(): any {
    if (!FormUtilService.validateForm(this.createSpecForm)) {
      return;
    }
    return this.createSpecForm.getRawValue();
  }

  createForm(): void {
    const formConfig: any = {
      name: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9]*$')]],
      version: ['', [Validators.required, Validators.pattern('^[0-9.]*$')]],
      releaseVersion: ['', [Validators.required]],
      status: [undefined, [Validators.required]],
      description: ['', [Validators.required]],
      releaseNotes: ['', [Validators.required]],
      productVersionMap: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9]*$')]],
      specVersion: ['', [Validators.required]],
      cbaseName: ['', [Validators.required]],
      cbaseVersion: ['', [Validators.required]],
      cbaseDisabled: ['', [Validators.required]],
      atfName: ['', [Validators.required]],
      atfVersion: ['', [Validators.required]],
    };
    this.createVersionForm = this.formBuilder.group(formConfig);
    if (localStorage.getItem('versionForm') || this.editData) {
     if (this.editData) {
      const editData = this.editData;
      editData.cbaseName = editData.cbase?.name;
      editData.cbaseVersion = editData.cbase?.version;
      editData.cbaseDisabled = editData.cbase?.disabled;
      editData.atfName = editData.atf?.name;
      editData.atfVersion = editData.atf?.version;
      editData.productVersionMap = typeof(editData.productVersionMap) !== 'string' ? JSON.stringify(editData.productVersionMap)
        : editData.productVersionMap ;
      this.editData = editData;
     }
      const keys = Object.keys(formConfig);
      const values = this.editData ? this.editData : JSON.parse(localStorage.getItem('versionForm'));
      keys.forEach(key => {
        this.createVersionForm.get(key).setValue(values[key]);
      });
      this.patchFlagValue = this.editData ? this.editData.patchFlag : localStorage.getItem('versionPatchFlag') === 'true';
    }
  }

  deleteCapability(index): void {
    this.loading = true;
    this.dataSource.splice(index, 1);
    this.updateCapabilityCount();
    if (!this.editData) {
      this.storeData();
    }
    setTimeout(() => {
      this.loading = false;
    }, 10);
  }

  editCapability(index): void {
    const capability = this.dataSource[index];
    this.matDialog.open(AddCapabilityDialogComponent, {
      minHeight: '533px',
      width: '900px',
      panelClass: 'flex-dialog',
      data: capability
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      if (data) {
        this.dataSource.splice(index, 1);
        this.dataSource = [...this.dataSource, data];
        this.updateCapabilityCount();
        if (!this.editData) {
          this.storeData();
        }
      }
    });
  }

  addCapability(): void {
    this.matDialog.open(AddCapabilityDialogComponent, {
      minHeight: '533px',
      width: '900px',
      panelClass: 'flex-dialog',
      data: {}
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      if (data) {
        this.dataSource = [...this.dataSource, data];
        this.updateCapabilityCount();
        if (!this.editData) {
          this.storeData();
        }
      }
    });
  }

  updateCapabilityCount(): void {
    this.capabilityCount.included = this.dataSource?.filter(item => item.type === 'mandatory').length;
    this.capabilityCount.optional = this.dataSource?.filter(item => item.type === 'optional').length;
  }

  specForm(): void {
    const formConfig: any = {
      installationSpecification: ['', [Validators.required]]
    };
    this.createSpecForm = this.formBuilder.group(formConfig);
    if (localStorage.getItem('specForm')) {
      const value = JSON.parse(localStorage.getItem('specForm'));
      this.createSpecForm.get('installationSpecification').setValue(value);
    }
  }

  encryptData(event): void {
    this.encryptionKeys.buildInstallSpec = event.checked;
    if (event.checked){
      this.createSpecForm.get('installationSpecification').setValue(atob(this.createSpecForm.get('installationSpecification').value));
    } else {
      this.createSpecForm.get('installationSpecification').setValue(btoa(this.createSpecForm.get('installationSpecification').value));
    }
  }

  tabChanged(event): void {
    if ((this.selectedIndex < event && this.validateTab(this.selectedIndex) &&
      (this.selectedIndex === event - 1 || this.validateTab(event))) ||
      (this.selectedIndex === 3 && this.validateTab(this.selectedIndex)) ||
      (this.selectedIndex > event && this.validateTab(event))) {
      this.changeEncryption();
      if (!this.editData) {
        this.storeData();
      }
      this.selectedIndex = event;
    }
  }

  nextTab(): void {
    if (this.validateTab(this.selectedIndex)) {
      this.changeEncryption();
      if (!this.editData) {
        this.storeData();
      }
      this.selectedIndex = this.selectedIndex + 1;
    }
  }

  changeEncryption(): void {
    if (this.selectedIndex === 2 && this.encryptionKeys.buildInstallSpec) {
      this.encryptionKeys.buildInstallSpec = false;
      this.createSpecForm.get('installationSpecification').setValue(atob(this.createSpecForm.get('installationSpecification').value));
    }
  }

  storeData(): void {
    switch (this.selectedIndex) {
      case 0:
        if (this.tabValidation.basic) {
          localStorage.setItem('versionForm', JSON.stringify(this.getVersionForm()));
          localStorage.setItem('versionPatchFlag', JSON.stringify(this.patchFlagValue));
        }
        return;
      case 1:
        localStorage.setItem('capabilities', JSON.stringify(this.dataSource));
        return;
      case 2:
        if (this.tabValidation.installSpec) {
          const data = this.encryptionKeys.buildInstallSpec ? atob(this.createSpecForm.get('installationSpecification').value) :
            this.createSpecForm.get('installationSpecification').value;
          localStorage.setItem('specForm', JSON.stringify(data));
        }
        return;
    }
  }

  validateTab(selectedIndex): any {
    if (selectedIndex === 0) {
      this.tabValidation.basic = this.getVersionForm() ? true : false;
      return this.tabValidation.basic;
    } else if (selectedIndex === 1) {
      this.tabValidation.capability = this.dataSource.length > 0;
      return this.tabValidation.capability;
    } else if (selectedIndex === 2) {
      this.tabValidation.installSpec = this.getSpecForm() ? true : false;
      return this.tabValidation.installSpec;
    } else if (selectedIndex === 3) {
      this.tabValidation.review =  this.dataSource.length > 0 && this.tabValidation.installSpec ? true : false;
      return this.tabValidation.review;
    }
  }

  sortData(event): void {
    this.sortInfo = event;
    this.loading = true;
    this.dataSource = this.sortInstanceData(event);
    setTimeout(() => {
      this.loading = false;
    }, 10);
  }

  sortInstanceData(event): any {
    return this.dataSource?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'version':
          comparatorResult = a?.version && b?.version ? a?.version?.localeCompare(b?.version) : !a?.version ? -1 : 1;
          break;
        case 'type':
          comparatorResult = a?.type && b?.type ? a?.type?.localeCompare(b?.type)
            : !a?.type ? -1 : 1;
          break;
        default:
          comparatorResult = a?.version && b?.version ? a?.version?.localeCompare(b?.version) : !a?.version ? -1 : 1;
          break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
     });
  }

  patchFlagChange(event): void {
    this.patchFlagValue = event.checked;
  }

  submitBuildVersion(): void {
    const versionData = this.getVersionForm();
    versionData.installationSpecification = this.getSpecForm().installationSpecification;
    if (!this.encryptionKeys.buildInstallSpec) {
      versionData.installationSpecification = btoa(versionData.installationSpecification);
    }
    versionData.patchFlag = this.patchFlagValue;
    const dataSource = this.dataSource;
    dataSource.map(item => item.name = item.capability);
    dataSource.forEach(item => {
      delete item.capabilityDetails;
      delete item.capability;
    });
    versionData.capabilities = dataSource;
    versionData.cbase = {};
    versionData.cbase.name = versionData.cbaseName;
    versionData.cbase.version = versionData.cbaseVersion;
    versionData.cbase.disabled = versionData.cbaseDisabled;
    versionData.atf = {};
    versionData.atf.name = versionData.atfName;
    versionData.atf.version = versionData.atfVersion;
    const deleteKeys = ['cbaseName', 'cbaseVersion', 'cbaseDisabled', 'atfName', 'atfVersion'];
    deleteKeys.forEach(key => delete versionData[key]);

    this.sidenavService.closeRightSidenav(versionData);
  }

}
